import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  hint?: string;
  className?: string;
}

export default function FormLabel({ children, hint, className }: Props) {
  return (
    <p className={clsx('mb-0', className)}>
      {children}
      {hint && (
        <>
          <br />
          <span className="text-xs font-normal">{hint}</span>
        </>
      )}
    </p>
  );
}
